
import Jump from 'jump.js';
import { easeInOutQuad } from '../../utilities/easing';
import { Notification } from '../../utilities/notification';
import 'whatwg-fetch'; 
import AjaxForm from '../../utilities/ajax-form';
import FormErrors from '../../utilities/FormErrors';
import AjaxReloadPartial from '../../utilities/AjaxReloadPartial';
import { CheckoutFormNotification } from '../../utilities/notifications/checkout-form';

export default class UpdateCheckoutBillingShipping extends AjaxForm {

  constructor(form, addressType='shipping') {
    form.dataset.addressType = addressType;
    super(form);
    this.addressType = addressType;
  }

  setRequestBody() {

//    console.log('this is this:', this); // hasAddressTypeProperty in console
//    console.log('address type of this is',this.hasOwnProperty('addressType')); // is false??
    let addressType = this.form.dataset.addressType; // quick hack to get around ^

    let addressForm = document.querySelector('.js-update-cart-billing-shipping');

    let data = {
      'address[fullName]' : document.getElementsByName(`${addressType}Address[fullName]`)[0].value,
      'address[organization]' : document.getElementsByName(`${addressType}Address[organization]`)[0].value,
      'address[addressLine1]' : document.getElementsByName(`${addressType}Address[addressLine1]`)[0].value,
      'address[addressLine2]' : document.getElementsByName(`${addressType}Address[addressLine2]`).length ?document.getElementsByName(`${addressType}Address[address2]`)[0].value : '',
      'address[locality]' : document.getElementsByName(`${addressType}Address[locality]`)[0].value,
      'address[administrativeArea]' : document.getElementsByName(`${addressType}Address[administrativeArea]`)[0].value,
      'address[postalCode]' : document.getElementsByName(`${addressType}Address[postalCode]`)[0].value,
      'address[countryCode]' : document.getElementsByName(`${addressType}Address[countryCode]`)[0].value, 
      'AddressId' : document.getElementsByName(`AddressId`)[0].value,
      //'address[primaryBilling]' : document.getElementsByName(`${addressType}Address[primaryBilling]`)[0].value,
      //'address[primaryShipping]' : document.getElementsByName(`${addressType}Address[primaryShipping]`)[0].value,
      'CRAFT_CSRF_TOKEN': window.csrfTokenValue,
      'action' : 'site-module/site-module/save-address',
    };

    return new URLSearchParams(data);
  }

  addErrorsToFormInputs(json, form = this.form) {
    let addressType = form.dataset.addressType;
    let Errors = new FormErrors(form, json, `${addressType}Address`);

    return Errors.addErrorsToFormInputs();
  }

  handleSuccess(json) {
    new AjaxReloadPartial('.js-checkout-address', false, false, function(partial) {
      document.querySelector('.js-update-cart-billing-shipping').classList.remove('is-editing');
    });
  }
};